<footer
    [innerHTML]="footer | unsafeHtml"
></footer>
